<template>
  <v-form
    ref="form"
    :value="value"
    @input="val => $emit('input', val)"
  >
    <slot />
    <anchor-form-buttons
      :dense="denseBtns"
      :prefix="prefix"
      :hide-cancel="hideCancel"
      :loading="loading"
      :valid="value"
      @cancel="$emit('cancel')"
      @submit="submitHandler"
    />
  </v-form>
</template>

<script>
export default {
  name: 'AnchorBaseForm',
  props: {
    loading: Boolean,
    denseBtns: {
      type: Boolean,
      default: true,
    },
    hideCancel: Boolean,
    prefix: String,
    value: undefined,
  },
  methods: {
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submitHandler() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
};
</script>
